import React from "react";
import './Contacto.css'
import { RiFacebookCircleLine, RiWhatsappLine, RiInstagramLine } from 'react-icons/ri';


export const Contacto = () => {
    return (
        <section className="contacto">
            <h1>Dónde encontrarnos</h1>
            <article className="info">
                <p>
                Ingresa en nuestras redes y enterate de los nuevos productos que
                lanzamos y de las novedades que tenemos para vos.
                </p>
            </article>
            <article className="redes">
                <figure className="redes__iconos instagram">
                    <a href={"https://www.instagram.com/yugen.timetorelax/"} target="_blank" rel="noopener noreferrer">
                        <RiInstagramLine/>
                    </a>
                    <figcaption class="logos__p">Nuestro instagram</figcaption>
                </figure>
                <figure className="redes__iconos  facebook">
                    <a href={"https://www.facebook.com/Yugen-144177610780208"} target="_blank" rel="noopener noreferrer">
                        <RiFacebookCircleLine/>
                    </a>
                    <figcaption class="logos__p">Nuestro facebook</figcaption>
                </figure>
                <figure className="redes__iconos  whatsapp">
                    <a href={"https://api.whatsapp.com/send?phone=+5491134371996"} target="_blank" rel="noopener noreferrer">
                        <RiWhatsappLine/>
                    </a>
                    <figcaption>Envianos un mensaje</figcaption>
                </figure>
            </article>
        </section>
    );
}